/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
let cardSliders = document.querySelectorAll('.cards-slider')

cardSliders.forEach( ( slide ) => {
	new Swiper( slide, {
    slidesPerView: 4,
    spaceBetween: 24,
    loop: false,
    navigation: {
        nextEl: slide.parentNode.querySelector( ".swiper-button-next" ),
        prevEl: slide.parentNode.querySelector( ".swiper-button-prev" ),
    },
		pagination: {
			el: slide.parentNode.querySelector( ".swiper-pagination" ),
			clickable: true
		},
  });
})
/* eslint-enable no-console */
